import React from 'react'
import styled from 'styled-components'

import {BoxedContainer, Section} from '../../elements'

const FeatureCards = props => (
  <Section padding="bottom" className={props.className}>
    <h2 className="visually-hidden">Highlights</h2>
    <StyledBoxedContainer>{props.children}</StyledBoxedContainer>
  </Section>
)

export default FeatureCards

const StyledBoxedContainer = styled(BoxedContainer)`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: 1fr;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`
